import React from 'react';
import { Link } from 'react-router-dom';
import { SignInProps } from './types';
import { useSignIn } from './useSignIn';
import PasswordInput from '../../components/PasswordInput';
import styles from './SignIn.module.css';

/**
 * サインイン（ログイン）ページコンポーネント
 */
const SignIn: React.FC<SignInProps> = ({ setCurrentUser }) => {
  const {
    formData,
    isLoading,
    error,
    handleInputChange,
    handleSubmit
  } = useSignIn({ setCurrentUser });

  return (
    <div className={styles['sign-in-container']} data-testid="sign-in__container">
      <form 
        onSubmit={handleSubmit} 
        className={styles['sign-in-form']} 
        name="login-form"
        autoComplete="on"
        data-testid="sign-in__form"
      >
        <h2 className={styles['sign-in-form-title']}>ログイン</h2>
        <p className={styles['sign-in-subtitle']}>登録済みのメールアドレスとパスワードで<br />ログインしてください。</p>

        {error && <div className={styles['sign-in-error-message']} data-testid="sign-in__error">{error}</div>}

        <div className={styles['sign-in-form-group']}>
          <label htmlFor="email" className={styles['sign-in-form-label']}>メールアドレス</label>
          <div className={styles['sign-in-input-container']}>
            <svg className={styles['sign-in-input-icon']} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
              <path fill="currentColor" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
            </svg>
            <input
              id="email"
              type="email"
              className={styles['sign-in-form-input']}
              placeholder="your-email@example.com"
              name="email"
              autoComplete="username email"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck="false"
              required
              value={formData.email}
              onChange={handleInputChange}
              data-testid="sign-in__email-input"
            />
          </div>
        </div>

        <div className={styles['sign-in-form-group']}>
          <label htmlFor="password" className={styles['sign-in-form-label']}>パスワード</label>
          <div className={styles['sign-in-input-container']}>
            <svg className={styles['sign-in-input-icon']} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
              <path fill="currentColor" d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
            </svg>
            <PasswordInput
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="••••••••"
              className={styles['sign-in-form-input']}
              autoComplete="current-password"
              required
              data-testid="sign-in__password-input"
            />
          </div>
          <div className={styles['sign-in-footer']}>
            <Link to="/forgot-password" className={styles['sign-in-forgot-link']} data-testid="sign-in__forgot-link">
              パスワードをお忘れですか？
            </Link>
          </div>
        </div>

        <button
          type="submit"
          className={styles['sign-in-submit-button']}
          disabled={isLoading}
          name="login-button"
          data-testid="sign-in__submit-button"
        >
          {isLoading ? (
            <span className={styles['sign-in-loading-spinner']} data-testid="sign-in__loading-spinner"></span>
          ) : 'ログイン'}
        </button>

      </form>
    </div>
  );
};

export default SignIn; 
